import { render, staticRenderFns } from "./ScoreRuleDialog.vue?vue&type=template&id=6db2b782&scoped=true&"
import script from "./ScoreRuleDialog.vue?vue&type=script&lang=ts&"
export * from "./ScoreRuleDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreRuleDialog.vue?vue&type=style&index=0&id=6db2b782&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db2b782",
  null
  
)

export default component.exports